import React from 'react';
import Svg from '../../Svg/Svg';
import { SvgProps } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="92"
      height="48"
      viewBox="0 0 240 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.9157 128C13.5307 128 16.1463 128 18.7608 128C86.2536 128 153.746 128 221.239 128C223.854 128 226.47 128 229.085 128C230.589 128 232.094 128 233.599 128C234.103 128.001 234.59 127.944 235.081 127.827C235.317 127.77 235.548 127.7 235.776 127.618C236.696 127.284 237.449 126.806 238.139 126.11C238.236 126.013 238.329 125.912 238.419 125.809C238.848 125.319 239.183 124.793 239.447 124.198C239.455 124.182 239.461 124.164 239.469 124.147C239.601 123.842 239.709 123.532 239.792 123.211C239.794 123.202 239.797 123.194 239.799 123.185C239.933 122.661 239.999 122.14 239.999 121.599C239.999 117.332 239.999 113.066 239.999 108.799C239.999 74.6662 239.999 40.5335 239.999 6.40023C239.999 2.86572 237.134 0 233.599 0C232.094 0 230.589 0 229.085 0C227.869 0 226.654 0 225.439 0C225.405 0 225.372 0 225.337 0C225.288 0 225.238 0 225.188 0C223.872 0 222.555 0 221.238 0C153.746 0 86.2535 0 18.7602 0C17.444 0 16.1272 0 14.8109 0C14.7612 0 14.711 0 14.6613 0C14.6274 0 14.5936 0 14.5597 0C13.345 0 12.1292 0 10.9146 0C9.40978 0 7.90499 0 6.4002 0C2.86568 0 3.33212e-07 2.86572 3.33212e-07 6.40023C3.33212e-07 40.5335 3.33212e-07 74.6662 3.33212e-07 108.799C3.33212e-07 113.066 3.33212e-07 117.332 3.33212e-07 121.599C-0.00112854 125.134 2.86625 127.998 6.4002 127.999C7.90612 128 9.41091 128 10.9157 128Z"
        fill="#E3E3E3"
      />
      <path
        d="M0.0012207 108.4C0.0012207 108.533 0.0012207 108.666 0.0012207 108.8C0.0012207 113.067 0.0012207 117.333 0.0012207 121.6C0.0012207 125.134 2.8663 127.999 6.40138 127.999C7.90618 127.999 9.41099 127.999 10.9158 127.999C13.5308 127.999 16.1464 127.999 18.7609 127.999C48.9211 127.999 135.08 127.999 165.239 127.999C167.855 127.999 226.47 127.999 229.085 127.999C230.59 127.999 232.094 127.999 233.599 127.999C234.103 128.001 234.59 127.943 235.081 127.826C235.317 127.77 235.548 127.7 235.776 127.618C236.696 127.284 237.449 126.805 238.139 126.11C238.236 126.013 238.33 125.912 238.42 125.809C238.848 125.318 239.184 124.793 239.447 124.198C239.455 124.182 239.462 124.164 239.47 124.147C239.601 123.842 239.709 123.532 239.792 123.211C239.794 123.202 239.797 123.194 239.799 123.185C239.933 122.661 239.999 122.14 239.999 121.599C239.999 117.332 239.999 113.066 239.999 108.799C239.999 108.666 239.999 108.533 239.999 108.399H0.0012207V108.4Z"
        fill="url(#paint0_linear_6150_22587)"
      />
      <path
        opacity="0.2"
        d="M19.6014 0.000610352C19.3214 0.000610352 19.0414 0.000610352 18.7615 0.000610352C17.4452 0.000610352 16.1284 0.000610352 14.8121 0.000610352C14.7624 0.000610352 14.7122 0.000610352 14.6625 0.000610352C14.6287 0.000610352 14.5948 0.000610352 14.5609 0.000610352C13.3457 0.000610352 12.1305 0.000610352 10.9158 0.000610352C9.41099 0.000610352 7.90618 0.000610352 6.40138 0.000610352C2.8663 0.000610352 0.0012207 2.86626 0.0012207 6.40077C0.0012207 40.5341 0.0012207 74.6662 0.0012207 108.8C0.0012207 113.067 0.0012207 117.333 0.0012207 121.6C0.0012207 125.134 2.8663 127.999 6.40138 127.999C7.90618 127.999 9.41099 127.999 10.9158 127.999C13.5308 127.999 16.1464 127.999 18.7609 127.999C19.0409 127.999 19.3208 127.999 19.6008 127.999V0.000610352H19.6014Z"
        fill="url(#paint1_linear_6150_22587)"
      />
      <path
        opacity="0.2"
        d="M220.4 0.000610352C220.68 0.000610352 220.959 0.000610352 221.239 0.000610352C222.556 0.000610352 223.873 0.000610352 225.189 0.000610352C225.239 0.000610352 225.288 0.000610352 225.338 0.000610352C225.372 0.000610352 225.406 0.000610352 225.44 0.000610352C226.655 0.000610352 227.871 0.000610352 229.085 0.000610352C230.59 0.000610352 232.095 0.000610352 233.6 0.000610352C237.134 0.000610352 239.999 2.86626 239.999 6.40077C239.999 40.5341 239.999 74.6662 239.999 108.8C239.999 113.067 239.999 117.333 239.999 121.6C239.999 125.134 237.134 127.999 233.6 127.999C232.095 127.999 230.59 127.999 229.085 127.999C226.47 127.999 223.855 127.999 221.24 127.999C220.96 127.999 220.68 127.999 220.4 127.999V0.000610352H220.4Z"
        fill="url(#paint2_linear_6150_22587)"
      />
      <path
        d="M131.856 19.6007C131.676 19.6007 131.601 19.6758 131.601 19.857C131.601 49.2862 131.601 78.7155 131.601 108.145C131.601 108.325 131.676 108.4 131.856 108.4C161.286 108.4 190.714 108.4 220.144 108.4C220.324 108.4 220.399 108.325 220.399 108.145C220.399 78.7155 220.399 49.2862 220.399 19.857C220.399 19.6758 220.324 19.6007 220.144 19.6007C190.714 19.6007 161.286 19.6007 131.856 19.6007Z"
        fill="#575756"
      />
      <path
        d="M220 107.744C220 107.925 219.924 108 219.743 108C190.581 108 161.419 108 132.256 108C132.076 108 132.001 107.925 132.001 107.744C132.001 78.5818 132.001 49.4189 132.001 20.2566C132.001 20.076 132.076 20.0009 132.256 20.0009C161.419 20.0009 190.581 20.0009 219.743 20.0009C219.924 20.0009 220 20.076 220 20.2566C220 49.4189 220 78.5818 220 107.744Z"
        fill="#E3E3E3"
      />
      <path
        d="M210.004 97.8539C210.004 97.513 209.868 97.3668 209.523 97.3668C208.524 97.3668 207.526 97.3668 206.528 97.3668C206.528 97.0936 206.528 96.8199 206.528 96.5467C206.528 95.9512 206.227 95.5459 205.951 95.0836C205.007 93.5105 204.833 91.6891 206.788 90.8526C208.463 90.1352 210.326 91.3696 210.327 93.1899C210.327 93.344 210.312 93.4942 210.279 93.6454C210.209 93.9779 210.32 94.1427 210.65 94.2144C210.983 94.2872 211.151 94.1783 211.218 93.8442C211.807 91.0705 208.897 88.837 206.338 90.002C205.151 90.5422 204.356 91.7009 204.288 93.0059C204.252 93.6838 204.419 94.2539 204.716 94.8483C204.926 95.2682 205.568 95.9833 205.568 96.5472C205.568 97.2883 205.568 98.03 205.568 98.7717C205.568 99.1115 205.708 99.2515 206.048 99.2515C206.223 99.2515 206.396 99.2515 206.571 99.2515C206.571 99.3999 206.571 99.5478 206.571 99.6957C206.571 100.035 206.711 100.175 207.051 100.175C207.541 100.175 208.031 100.175 208.521 100.175C208.861 100.175 209.001 100.035 209.001 99.6957C209.001 99.5478 209.001 99.3999 209.001 99.2515C209.176 99.2515 209.35 99.2515 209.524 99.2515C209.864 99.2515 210.004 99.1115 210.004 98.7717C210.004 98.4652 210.004 98.1593 210.004 97.8539Z"
        fill="#575756"
      />
      <path
        d="M19.857 19.6007C19.6764 19.6007 19.6013 19.6758 19.6013 19.857C19.6013 49.2862 19.6013 78.7149 19.6013 108.144C19.6013 108.325 19.6764 108.4 19.857 108.4C49.2862 108.4 78.7149 108.4 108.144 108.4C108.326 108.4 108.4 108.325 108.4 108.144C108.4 78.7149 108.4 49.2862 108.4 19.857C108.4 19.6758 108.326 19.6007 108.144 19.6007C78.7149 19.6007 49.2857 19.6007 19.857 19.6007Z"
        fill="#575756"
      />
      <path
        d="M107.745 20.2566V20.0009H20.2578"
        stroke="#010202"
        strokeWidth="0.2835"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M107.745 20.0009C107.925 20.0009 108 20.076 108 20.2566C108 49.4195 108 78.5818 108 107.744C108 107.925 107.925 108 107.745 108C78.5817 108 49.4194 108 20.2572 108C20.0765 108 20.0015 107.925 20.0015 107.744C20.0015 78.5818 20.0015 49.4195 20.0015 20.2566C20.0015 20.076 20.0765 20.0009 20.2572 20.0009"
        fill="#E3E3E3"
      />
      <path
        d="M64.0006 94.8794C81.0548 94.8794 94.8799 81.0542 94.8799 64.0001C94.8799 46.9459 81.0548 33.1208 64.0006 33.1208C46.9465 33.1208 33.1213 46.9459 33.1213 64.0001C33.1213 81.0542 46.9465 94.8794 64.0006 94.8794Z"
        fill="url(#paint3_linear_6150_22587)"
      />
      <path
        d="M48.6411 68.5601C51.1596 68.5601 53.2012 66.5185 53.2012 64.0001C53.2012 61.4816 51.1596 59.44 48.6411 59.44C46.1227 59.44 44.0811 61.4816 44.0811 64.0001C44.0811 66.5185 46.1227 68.5601 48.6411 68.5601Z"
        fill="#3C3C3B"
      />
      <path
        d="M79.3606 68.5601C81.8791 68.5601 83.9207 66.5185 83.9207 64.0001C83.9207 61.4816 81.8791 59.44 79.3606 59.44C76.8422 59.44 74.8005 61.4816 74.8005 64.0001C74.8005 66.5185 76.8422 68.5601 79.3606 68.5601Z"
        fill="#3C3C3B"
      />
      <path
        d="M96.6691 98.0227C96.2571 98.4359 96.2571 99.1054 96.6691 99.5185C97.0834 99.9328 97.7506 99.93 98.1638 99.5173C98.5775 99.1053 98.5781 98.4359 98.1649 98.0227C97.7517 97.6107 97.0823 97.6107 96.6691 98.0227Z"
        fill="#575756"
      />
      <path
        d="M93.6539 98.2908C92.9218 98.2908 92.1898 98.2908 91.4577 98.2908C91.3284 98.2908 91.2759 98.2378 91.2759 98.1091C91.2759 96.3441 91.2759 94.5791 91.2759 92.8141C91.2759 92.6848 91.329 92.6323 91.4577 92.6323C93.2227 92.6323 94.9877 92.6323 96.7527 92.6323C96.8814 92.6323 96.9339 92.6854 96.9344 92.8141C96.9344 93.5461 96.9344 94.2783 96.9344 95.0115C96.9344 95.3513 97.0744 95.4912 97.4142 95.4912C97.754 95.4912 97.8951 95.3513 97.8951 95.0115C97.8951 94.2783 97.8951 93.5461 97.8951 92.8141C97.894 92.1836 97.3832 91.6734 96.7533 91.6722C94.9883 91.6722 93.2232 91.6722 91.4582 91.6722C90.8278 91.6722 90.3164 92.1836 90.3164 92.8141C90.3164 94.5791 90.3164 96.3441 90.3164 98.1091C90.3164 98.7395 90.8278 99.251 91.4582 99.251C92.1903 99.251 92.9224 99.251 93.6545 99.251C93.9932 99.251 94.1343 99.111 94.1343 98.7712C94.1343 98.4314 93.992 98.2908 93.6539 98.2908Z"
        fill="#575756"
      />
      <path
        d="M67.1207 41.5997V33.2878C66.0889 33.1823 65.0487 33.1202 64.0005 33.1202C62.9478 33.1202 61.907 33.1738 60.8809 33.2765V41.5992H67.1207V41.5997Z"
        fill="#3C3C3B"
      />
      <path
        d="M37.6007 59.3101C37.6007 55.5312 37.6007 51.7518 37.6007 47.9728C35.4553 51.4995 34.0047 55.4923 33.4182 59.76C34.6622 59.76 35.9063 59.76 37.1509 59.76C37.4686 59.76 37.6007 59.629 37.6007 59.3101Z"
        fill="#D0D0D0"
      />
      <path
        d="M90.8939 59.7599C92.125 59.7599 93.3566 59.7599 94.5882 59.7599C94.5803 59.7069 94.573 59.6533 94.5651 59.6002C94.5572 59.5472 94.5498 59.4936 94.5419 59.4405C93.9526 55.4928 92.7216 51.9746 90.7207 48.5208C90.6191 48.3464 90.5045 48.18 90.4006 48.0084C90.4006 51.7607 90.4006 55.5148 90.4006 59.2672C90.4006 59.6155 90.5451 59.7599 90.8939 59.7599Z"
        fill="#D0D0D0"
      />
      <path
        d="M60.8804 86.3998V94.723C61.9065 94.8258 62.9473 94.8794 64 94.8794C65.0533 94.8794 66.0941 94.8252 67.1202 94.723V86.3998H60.8804Z"
        fill="#3C3C3B"
      />
      <path
        d="M37.0747 68.2401C35.856 68.2401 34.6374 68.2401 33.4182 68.2401C34.0047 72.509 35.4553 76.5007 37.6007 80.0273C37.6007 76.2738 37.6007 72.5208 37.6007 68.7673C37.6007 68.3942 37.4466 68.2401 37.0747 68.2401Z"
        fill="#D0D0D0"
      />
      <path
        d="M91.0125 68.2401C90.5796 68.2401 90.4006 68.4196 90.4006 68.8509C90.4006 72.5773 90.4006 76.302 90.4006 80.0273C92.5461 76.5007 93.9967 72.509 94.5831 68.2401C93.3933 68.2401 92.2023 68.2401 91.0125 68.2401Z"
        fill="#D0D0D0"
      />
      <path
        d="M62.1034 94.8094C62.7333 94.85 63.3649 94.8799 64.0004 94.8799C64.6382 94.8799 65.2687 94.8534 65.897 94.815V85.2715H62.1028V94.8094H62.1034Z"
        fill="url(#paint4_linear_6150_22587)"
      />
      <path
        d="M65.8976 33.1913C65.2677 33.1501 64.6361 33.1208 64.0005 33.1208C63.3627 33.1208 62.7322 33.1467 62.104 33.1851V42.7286H65.8982V33.1913H65.8976Z"
        fill="url(#paint5_linear_6150_22587)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6150_22587"
          x1="120"
          y1="109.076"
          x2="120"
          y2="127.44"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.005" stopColor="#D9D9D9" stopOpacity="0" />
          <stop offset="0.2624" stopColor="#E5E5E5" stopOpacity="0.5" />
          <stop offset="0.5198" stopColor="#EBEBEB" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_6150_22587"
          x1="16.5601"
          y1="63.9996"
          x2="0.309462"
          y2="63.9996"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="0.5297" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_6150_22587"
          x1="223.441"
          y1="63.9999"
          x2="239.691"
          y2="63.9999"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.005" stopColor="white" stopOpacity="0" />
          <stop offset="0.5297" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_6150_22587"
          x1="64.0007"
          y1="94.8798"
          x2="64.0007"
          y2="33.1206"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C6C6C6" />
          <stop offset="0.2003" stopColor="#C0C0C0" />
          <stop offset="0.5079" stopColor="#AFAFAF" />
          <stop offset="0.8825" stopColor="#929291" />
          <stop offset="1" stopColor="#878787" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_6150_22587"
          x1="64.0011"
          y1="94.7475"
          x2="64.0011"
          y2="85.2424"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#716033" />
          <stop offset="0.0653" stopColor="#796637" />
          <stop offset="0.1656" stopColor="#8B7640" />
          <stop offset="0.2885" stopColor="#A98E4E" />
          <stop offset="0.4279" stopColor="#CFAD5E" />
          <stop offset="0.4604" stopColor="#D9B562" />
          <stop offset="0.5059" stopColor="#DEBA6B" />
          <stop offset="0.5755" stopColor="#EBC983" />
          <stop offset="0.6188" stopColor="#F5D597" />
          <stop offset="0.6799" stopColor="#F1D08E" />
          <stop offset="0.7734" stopColor="#E3C075" />
          <stop offset="0.8317" stopColor="#D9B562" />
          <stop offset="0.8632" stopColor="#D3B060" />
          <stop offset="0.9116" stopColor="#C2A259" />
          <stop offset="0.9706" stopColor="#A68C4C" />
          <stop offset="1" stopColor="#957E45" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_6150_22587"
          x1="64.0006"
          y1="33.2529"
          x2="64.0006"
          y2="42.7573"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#716033" />
          <stop offset="0.0653" stopColor="#796637" />
          <stop offset="0.1656" stopColor="#8B7640" />
          <stop offset="0.2885" stopColor="#A98E4E" />
          <stop offset="0.4279" stopColor="#CFAD5E" />
          <stop offset="0.4604" stopColor="#D9B562" />
          <stop offset="0.5059" stopColor="#DEBA6B" />
          <stop offset="0.5755" stopColor="#EBC983" />
          <stop offset="0.6188" stopColor="#F5D597" />
          <stop offset="0.6799" stopColor="#F1D08E" />
          <stop offset="0.7734" stopColor="#E3C075" />
          <stop offset="0.8317" stopColor="#D9B562" />
          <stop offset="0.8632" stopColor="#D3B060" />
          <stop offset="0.9116" stopColor="#C2A259" />
          <stop offset="0.9706" stopColor="#A68C4C" />
          <stop offset="1" stopColor="#957E45" />
        </linearGradient>
      </defs>
    </Svg>
  );
};

export default Icon;
